import { plainToClass } from "class-transformer";
import { getDisplayDate } from "../../../shared/scripts/date-functions";
import { TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { TeamsAccessModal } from "../../list-management/scripts/special-case-sections/TeamsAccessModal";
import { ListInformation, AppUserExtended, CombineDisplayOption, UserRequestExtended, AppUserAccess, AppUserAffiliation } from "../../list-management/scripts/list-management.objects";
import { PmUserTable, PmUserTableInfo } from "../../project-manager-dashboard/pm-users/scripts/pm-users.table";
import { ListController, AddNewController, EditController } from "../../list-management/scripts/list-management.controllers";
import { FilterTab, Filter } from "../../list-management/scripts/list-management.filters";
import { Section, SectionField } from "../../list-management/scripts/list-management.form-sections";
import { PickListController } from "../../list-management/scripts/list-management.pick-list-controller";
import { ReviewRequestController, ViewUserRequestController, NewAddRequestController } from "../../project-manager-dashboard/pm-users/scripts/pm-users.controllers"
import _ from "lodash";

declare var $: any;
export class UserManagementPage {
    loadingContent: JQuery<HTMLElement>;
    loadedContent: JQuery<HTMLElement>;

    userListInfo: ListInformation;
    userListController: ListController;
    teamsAccessModal: TeamsAccessModal;

    currentListController: ListController;
    currentListIndex: string;

    userRequestTableInfo: PmUserTableInfo;
    userRequestTable: PmUserTable;
    reviewRequestController: ReviewRequestController;

    previousUserUpdateTable: PmUserTable;
    previousUserUpdateTableInfo: PmUserTableInfo;
    viewRequestController: ViewUserRequestController;
    newAddRequestController: NewAddRequestController;

    pmReviewUpdateTableInfo: PmUserTableInfo;
    pmReviewUpdateTable: PmUserTable;

    pickListController: PickListController;

    currentRequests: UserRequestExtended[] = undefined;
    constructor() {
        $(async () => {
            // For Multiple Modals
            $('body').on('hidden.bs.modal', function () {
                if ($('.modal.show').length > 0) {
                    $('body').addClass('modal-open');
                }
            });

            this.loadingContent = $("#loading-content-container");
            this.loadedContent = $("#loaded-content");

            // ----- Users -------
            let affiliationOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("RoleId", "pl-member-roles", "<br>"),
                new CombineDisplayOption("CenterId", "pl-center", ""),
                new CombineDisplayOption("CoreId", "pl-core", "", " - "),
                new CombineDisplayOption("ProjectId", "pl-project", "", " - ")
            ];

            let groupOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("GroupRoleId", "pl-group-roles", " - "),
                new CombineDisplayOption("GroupId", "pl-groups", "")
            ]

            let accessOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("CenterId", "pl-center", " - "),
                new CombineDisplayOption("AccessTypeId", "pl-access", "")
            ]

            this.userListInfo = {
                id: "revampp-users",
                handler: "Users",
                propId: "AppUser.Id",
                columns: [
                    { data: "AppUser.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "AppUser.FirstName", title: "First Name", className: "general text-left font-size12 nowrap" },
                    { data: "AppUser.LastName", title: "Last Name", className: "general text-left font-size12 nowrap" },
                    { data: "AppUser.IsActive", title: "Portal Access", className: "general text-center font-size12 nowrap", render: (data, type) => { return this.currentListController.getTrueFalseDisplay(data) } },
                    { data: "AppUser.IsVisible", title: "Visible in Directory", className: "general text-center font-size12 nowrap", render: (data, type) => { return this.currentListController.getTrueFalseDisplay(data) } },
                    { data: "AppUser.SentWelcomeEmail", title: "Sent Welcome Email", className: "general text-center font-size12 nowrap", render: (data, type) => { return this.currentListController.getTrueFalseDisplay(data) } },
                    { data: "AppUser.SentWelcomeEmailDate", title: "Welcome Email Date", className: "general text-left font-size12 nowrap", render: (data, type) => { return getDisplayDate(data) } },
                    { data: "AppUser.OrganizationIds", title: "Organization/Institution", className: "user-bio text-left font-size12 nowrap", render: (data, type) => { return this.currentListController.getMultiSelectString(data, "pl-organization-names") } },
                    { data: "AppUser.TerminalDegreeIds", title: "Terminal Degrees", className: "user-bio font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getMultiSelectString(data, "pl-degrees") } },
                    { data: "AppUser.OrcidLink", title: "ORCID Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUser.BioLink", title: "External Bio Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUser.LinkedinLink", title: "Linkedin Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUserAffiliationList", title: "ReVAMPP Affiliations", className: "user-affiliations font-size12 text-left lh-normal nowrap", render: (data, type) => { return this.currentListController.getCombinedContent(data, affiliationOptions) } },
                    //{ data: "AppUserAffiliationList", title: "Center Affiliations", className: "user-affiliations font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getDisplayContent(data, "CenterId", "pl-center") } },
                    //{ data: "AppUserAffiliationList", title: "Core Affiliations", className: "user-affiliations font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getDisplayContent(data, "CoreId", "pl-core") } },
                    //{ data: "AppUserAffiliationList", title: "Project Affiliations", className: "user-affiliations font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getDisplayContent(data, "ProjectId", "pl-project") } },
                    { data: "AppUserGroupList", title: "Group Affiliations", className: "user-groups font-size12 text-left lh-normal nowrap", render: (data, type) => { return this.currentListController.getCombinedContent(data, groupOptions) } },
                    //{ data: "AppUserGroupList", title: "Group Roles", className: "user-groups font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getDisplayContent(data, "GroupRoleId", "pl-group-roles") } },
                    { data: "AppUserRoleList", title: "User Permissions", className: "user-permissions font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getDisplayStringForStringArray(data) } },
                    { data: "AppUserAccessList", title: "User Access", className: "user-permissions font-size12 text-left nowrap", render: (data, type) => { return this.currentListController.getCombinedContent(data, accessOptions) } },
                    {
                        data: "AppUser.LastLoginDate", title: "Ever Logged In", className: "user-metrics text-center font-size12 nowrap", render: (data) => {
                            let everLoggedIn = false;
                            if (data) { everLoggedIn = true }
                            return this.currentListController.getTrueFalseDisplay(everLoggedIn);
                        }
                    },
                    { data: "AppUser.LastLoginDate", title: "Last Login Date", className: "user-metrics text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data); } },
                    { data: "AppUser.HasAcceptedAttestation", title: "Accepted Attestation", className: "user-metrics text-center font-size12 nowrap", render: (data) => { return this.currentListController.getTrueFalseDisplay(data) } },
                    { data: "AppUser.AttestationLastUpdated", title: "Attestation Date", className: "user-metrics text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data); } },
                    {
                        data: "AppUser.Expertise", title: "Added Expertise", className: "user-metrics text-center font-size12 nowrap", render: (data) => {
                            let hasExpertise = false;
                            if (data) { hasExpertise = true };
                            return this.currentListController.getTrueFalseDisplay(hasExpertise);
                        }
                    },
                    // Centers
                    {
                        data: "AppUserAffiliationList", title: "Is BP4", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 4)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is FLARE", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 2)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is MLvax", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 5)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is PABVAX", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 1)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is PROVIDENT", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 6)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is R2P2", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 7)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is VPPC", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 3)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                    {
                        data: "AppUserAffiliationList", title: "Is CDSC", className: "d-none", render: ((data: AppUserAffiliation[], type) => {
                            let result = "No";
                            if (data.some(x => x.CenterId == 8)) {
                                result = "Yes"
                            }
                            return result;
                        })
                    },
                ],
                tableColumnGroups: [
                    new TableColumnGroup("General", true, [], "general"),
                    new TableColumnGroup("User Bio", false, [], "user-bio"),
                    new TableColumnGroup("User Affiliations", false, [], "user-affiliations"),
                    new TableColumnGroup("User Groups", false, [], "user-groups"),
                    new TableColumnGroup("User Permissions", false, [], "user-permissions"),
                    new TableColumnGroup("User Metrics", false, [], "user-metrics")
                ],
                displayName: "Users",
                filterTabs: [
                    new FilterTab("general", "General", "General",
                        [
                            new Filter("is-active-filter", "Portal Access", "yes-no", "AppUser.IsActive"),
                            new Filter("is-visible-filter", "Visible in Directory", "yes-no", "AppUser.IsVisible"),
                            new Filter("sent-welcome-email-filter", "Sent Welcome Email", "yes-no", "AppUser.SentWelcomeEmail"),
                        ]
                    ),
                    new FilterTab("user-bio", "User Bio", "User Bio",
                        [
                            new Filter("organization-name-filter", "Organization/Institution", "multi-select-pl-multi", "AppUser.OrganizationIds", "pl-organization-names"),
                            new Filter("user-degree-filter", "Terminal Degrees", "multi-select-pl-multi", "AppUser.TerminalDegreeIds", "pl-degrees")
                        ]
                    ),
                    new FilterTab("user-affiliations", "Affiliations", "User Affiliations",
                        [
                            new Filter("user-affiliation-role-filter", "Member Roles", "multi-select-pl-nested-single", "AppUserAffiliationList", "pl-member-roles", ["RoleId"]),
                            new Filter("user-affiliation-center-filter", "Center Affiliations", "multi-select-pl-nested-single", "AppUserAffiliationList", "pl-center", ["CenterId"]),
                            new Filter("user-affiliation-core-filter", "Core Affiliations", "multi-select-nested-combined", "AppUserAffiliationList", "pl-core", ["CoreId", "CenterId"], ["pl-center"]),
                            new Filter("user-affiliation-project-filter", "Project Affiliations", "multi-select-nested-combined", "AppUserAffiliationList", "pl-project", ["ProjectId", "CenterId"], ["pl-center"]),
                        ]
                    ),
                    new FilterTab("user-groups", "Groups", "User Groups",
                        [
                            new Filter("user-group-name-filter", "Groups/Committees", "multi-select-pl-nested-single", "AppUserGroupList", "pl-groups", ["GroupId"]),
                            new Filter("user-group-role-filter", "Group Roles", "multi-select-pl-nested-single", "AppUserGroupList", "pl-group-roles", ["GroupRoleId"]),
                        ]
                    ),
                    new FilterTab("user-permissions", "Permissions", "User Permissions",
                        [
                            new Filter("user-permissions-filter", "User Permissions", "multi-select-list-array", "AppUserRoleList"),
                            new Filter("user-access-filter", "User Access", "multi-select-pl-nested-single", "AppUserAccessList", "pl-access", ["AccessTypeId"])
                        ]
                    ),
                    new FilterTab("user-metrics", "User Metrics", "User Metrics",
                        [
                            new Filter("user-last-login-filter", "Ever Logged In", "yes-no-not-null", "AppUser.LastLoginDate"),
                            new Filter("user-has-attested-filter", "Accepted Attestation", "yes-no", "AppUser.HasAcceptedAttestation"),
                            new Filter("user-added-expertise-filter", "Added Expertise", "yes-no-not-null", "AppUser.Expertise")
                        ]
                    )
                ],
                addNewModalId: "add-new-modal",
                addNewController: new AddNewController("revampp-user-add-controller", "Add New User", "SaveUsers",
                    [
                        new Section("revampp-user-general", "General Information",
                            [
                                new SectionField("add-user-email", "Email", "input-email", "AppUser.Email", true),
                                new SectionField("add-user-first-name", "First Name", "input", "AppUser.FirstName", true),
                                new SectionField("add-user-last-name", "Last Name", "input", "AppUser.LastName", true),
                                new SectionField("add-user-send-welcome-email", "Sent Welcome Email", "yes-no", "AppUser.SentWelcomeEmail", true, "", "Set this to \"Yes\" if the person has already been sent a welcome email, or if they do not need to be sent a welcome email."),
                            ]
                        ),
                        new Section("revampp-user-bio", "Bio Information",
                            [
                                new SectionField("add-user-organization-name", "Organization/Institution", "multi-dropdown-pl-search", "AppUser.OrganizationIds", true, "pl-organization-names"),
                                new SectionField("add-user-degrees", "Terminal Degrees", "multi-dropdown-pl", "AppUser.TerminalDegreeIds", false, "pl-degrees"),
                                new SectionField("add-user-orcid-link", "ORCID Link", "input-url-orcid", "AppUser.OrcidLink", false, "", "Please enter a valid ORCID Link. It should start with 'https://orcid.org/'"),
                                new SectionField("add-user-linkedin-link", "LinkedIn Link", "input-url-linkedin", "AppUser.LinkedinLink", false, "", "Please enter a valid LinkedIn Link. It should start with 'https://www.linkedin.com/'"),
                                new SectionField("add-user-bio-link", "External Bio Link", "input-url", "AppUser.BioLink", false, "", "Please enter a valid URL. It should start with 'https://'"),
                            ]
                        ),
                        new Section("revampp-user-affiliations", "User Affiliations",
                            [
                                new SectionField("add-user-affiliations", "User Affiliations", "affiliation-selection", "AppUserAffiliationList", true, "pl-member-roles", "", undefined, ["pl-center", "pl-all-cores", "pl-all-projects"])
                            ],
                        ),
                        new Section("revampp-user-groups", "User Groups",
                            [
                                new SectionField("add-user-groups", "User Groups/Committees", "group-selection-teams", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"])
                            ],
                        ),
                        new Section("revampp-user-access", "User Access",
                            [
                                new SectionField("add-user-access", "User Access", "access-selection", "AppUserAccessList", false, "pl-access", "", undefined, ["pl-center", "pl-limited-center"])
                            ]
                        ),
                        new Section("revampp-user-permissions", "User Permissions/Visibility",
                            [
                                new SectionField("add-user-active", "Portal Access", "yes-no", "AppUser.IsActive", true),
                                new SectionField("add-user-visible", "Visible in Directory", "yes-no", "AppUser.IsVisible", true),
                                new SectionField("add-user-permissions", "User Permissions", "permissions-selection-new", "AppUserRoleList", false, "pl-portal-roles")
                            ],
                        )
                    ],
                    "add-new-modal"),
                defaultItem: new AppUserExtended(),
                editModalId: "edit-item-modal",
                editController: new EditController("revampp-user-edit-controller", "Edit Users", "SaveUsers",
                    [
                        new Section("edit-revampp-user-general", "General Information",
                            [
                                new SectionField("edit-user-email", "Email", "input-email", "AppUser.Email", true),
                                new SectionField("edit-user-first-name", "First Name", "input", "AppUser.FirstName", true),
                                new SectionField("edit-user-last-name", "Last Name", "input", "AppUser.LastName", true),
                                new SectionField("edit-user-send-welcome-email", "Sent Welcome Email", "yes-no", "AppUser.SentWelcomeEmail", true, "", "Set this to \"Yes\" if the person has already been sent a welcome email, or if they do not need to be sent a welcome email."),
                            ], "", "", false
                        ),
                        new Section("edit-revampp-user-bio", "Bio Information",
                            [
                                new SectionField("edit-user-organization-name", "Organization/Institution", "multi-dropdown-pl-search", "AppUser.OrganizationIds", true, "pl-organization-names"),
                                new SectionField("edit-user-degrees", "Terminal Degrees", "multi-dropdown-pl", "AppUser.TerminalDegreeIds", false, "pl-degrees"),
                                new SectionField("edit-user-orcid-link", "ORCID Link", "input-url-orcid", "AppUser.OrcidLink", false, "", "Please enter a valid ORCID Link. It should start with 'https://orcid.org/'"),
                                new SectionField("edit-user-linkedin-link", "LinkedIn Link", "input-url-linkedin", "AppUser.LinkedinLink", false, "", "Please enter a valid LinkedIn Link. It should start with 'https://www.linkedin.com/'"), 
                                new SectionField("edit-user-bio-link", "External Bio Link", "input-url", "AppUser.BioLink", false, "", "Please enter a valid URL. It should start with 'https://'"),
                            ], "", "", false
                        ),
                        new Section("edit-revampp-user-affiliations", "User Affiliations",
                            [
                                new SectionField("edit-user-affiliations", "User Affiliations", "affiliation-selection", "AppUserAffiliationList", true, "pl-member-roles", "", undefined, ["pl-center", "pl-all-cores", "pl-all-projects"])
                            ], "", "", false, true
                        ),
                        new Section("edit-revampp-user-groups", "User Groups",
                            [
                                new SectionField("edit-user-groups", "User Groups/Committees", "group-selection-teams", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"])
                            ], "", "", false, true
                        ),
                        new Section("edit-revampp-user-access", "User Access",
                            [
                                new SectionField("edit-user-access", "User Access", "access-selection", "AppUserAccessList", false, "pl-access", "", undefined, ["pl-center", "pl-limited-center"])
                            ], "", "", false, true
                        ),
                        new Section("edit-revampp-user-permissions", "User Permissions/Visibility",
                            [
                                new SectionField("edit-user-active", "Portal Access", "yes-no", "AppUser.IsActive", true),
                                new SectionField("edit-user-visible", "Visible in Directory", "yes-no", "AppUser.IsVisible", true),
                                new SectionField("edit-user-permissions", "User Permissions", "permissions-selection", "AppUserRoleList", false, "pl-portal-roles"),
                                new SectionField("edit-user-pm-centers", "PM - Centers", "multi-dropdown-pl", "AppUser.ProjectManagerCenterIds", false, "pl-center", "If the user has access to the PM Dashboard. Use this role to specify which centers they will be able to modify. This will also include all of the cores and projects within the specified centers.")
                            ],
                        ),
                        /*new Section("edit-revampp-user-profile-pic", "User Profile Picture (Dev)",
                            [
                                new SectionField("edit-user-profile-pic", "Profile Picture Path", "input", "AppUser.ProfilePicturePath", false, "", "This is currently only for developers, don't worry too much about it.")
                            ]
                        )*/
                    ]
                    , "edit-item-modal", "AppUser.Email")
            }

            // Default Loading to Users
            await this.setRequestsFoundCount();
            this.userListController = new ListController(this.userListInfo);
            this.currentListController = this.userListController;
            this.currentListIndex = "1";
            this.teamsAccessModal = new TeamsAccessModal("teams-access-modal");

            // User Requests Table
            this.userRequestTableInfo = {
                tableId: "in-progress-user-table",
                propName: "UserRequest.Id",
                hasFilters: false,
                tableFilters: [],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.userRequestTable.getDisplayStatus(data) } },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.userRequestTable.getPickListContent(data, "pl-request-type") } },
                    { data: "UserRequest.RequestUserId", title: "Requested By", className: "text-left font-size12 nowrap", render: (data) => { return this.userRequestTable.getPickListContent(data, "pl-user") } },
                    {
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.CreateDate;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.CreateDate);
                            }
                        },
                        title: "Request Date", className: "text-left font-size12 nowrap"
                    }
                    //{ data: "UserRequest.CreateDate", title: "Request Date", className: "text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data) } }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {
                    let foundRequest = this.currentRequests.find(request => request.UserRequest.Id == requestId);
                    if (foundRequest) {
                        // If request is for a new user (add)
                        if (foundRequest.UserRequest.TypeId == 1) {
                            this.newAddRequestController.openModal(requestId);
                        }
                        // If its for an update request (edit)
                        else {
                            this.reviewRequestController.openModal(requestId);
                        }
                    }
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/user-management/user-management?handler=UserRequests",
                tableVariableName: "userUpdateTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId == 2) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [6, 'asc']
            }

            // Review Request Controller
            this.reviewRequestController = new ReviewRequestController("user-management-review-requests", "Review Request", "CompleteRequest",
                [
                    new Section("user-review-revampp-user-groups", "User Groups",
                        [
                            new SectionField("user-review-user-groups", "User Groups/Committees", "group-selection-teams", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"])
                        ], "", "", false, true
                    ),
                    new Section("user-review-revampp-user-permissions", "User Permissions/Visibility",
                        [
                            new SectionField("user-review-user-active", "Portal Access", "yes-no", "AppUser.IsActive", true),
                            new SectionField("user-review-user-visible", "Visible in Directory", "yes-no", "AppUser.IsVisible", true)
                        ], "", "", false, true
                    ),
                ], "review-request-modal", "AppUser.Email"
            );

            // New User Add Controller
            this.newAddRequestController = new NewAddRequestController("user-management-review-new-add-requests", "Review Request",
                [
                    new Section("revampp-user-general", "General Information",
                        [
                            new SectionField("add-user-email", "Email", "input-email", "AppUser.Email", true),
                            new SectionField("add-user-first-name", "First Name", "input", "AppUser.FirstName", true),
                            new SectionField("add-user-last-name", "Last Name", "input", "AppUser.LastName", true),
                            new SectionField("add-user-send-welcome-email", "Sent Welcome Email", "yes-no", "AppUser.SentWelcomeEmail", true, "", "Set this to \"Yes\" if the person has already been sent a welcome email, or if they do not need to be sent a welcome email."),
                        ]
                    ),
                    new Section("revampp-user-bio", "Bio Information",
                        [
                            new SectionField("add-user-organization-freetext", "Free Text Organization", "input-readonly", "AppUser.OrganizationIds", false),
                            new SectionField("add-user-organization-name", "Organization/Institution", "multi-dropdown-pl-search", "AppUser.OrganizationIds", true, "pl-organization-names", "If the submitted organization/institution name does not appear on this list, please add it."),
                            new SectionField("add-user-degrees", "Terminal Degrees", "multi-dropdown-pl", "AppUser.TerminalDegreeIds", false, "pl-degrees"),
                            new SectionField("add-user-orcid-link", "ORCID Link", "input-url-orcid", "AppUser.OrcidLink", false, "", "Please enter a valid ORCID Link. It should start with 'https://orcid.org/'"),
                            new SectionField("add-user-linkedin-link", "LinkedIn Link", "input-url-linkedin", "AppUser.LinkedinLink", false, "", "Please enter a valid LinkedIn Link. It should start with 'https://www.linkedin.com/'"),
                            new SectionField("add-user-bio-link", "External Bio Link", "input-url", "AppUser.BioLink", false, "", "Please enter a valid URL. It should start with 'https://'"),
                        ]
                    ),
                    new Section("revampp-user-affiliations", "User Affiliations",
                        [
                            new SectionField("add-user-affiliations", "User Affiliations", "affiliation-selection", "AppUserAffiliationList", true, "pl-member-roles", "", undefined, ["pl-center", "pl-all-cores", "pl-all-projects"])
                        ],
                    ),
                    new Section("revampp-user-groups", "User Groups",
                        [
                            new SectionField("add-user-groups", "User Groups/Committees", "group-selection-teams", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"])
                        ],
                    ),
                    new Section("revampp-user-permissions", "User Permissions/Visibility",
                        [
                            new SectionField("add-user-active", "Portal Access", "yes-no", "AppUser.IsActive", true),
                            new SectionField("add-user-visible", "Visible in Directory", "yes-no", "AppUser.IsVisible", true),
                            new SectionField("add-user-permissions", "User Permissions", "permissions-selection", "AppUserRoleList", false, "pl-portal-roles")
                        ],
                    )
                ], "add-new-modal"    
            )

            // Previous Requests
            this.previousUserUpdateTableInfo = {
                tableId: "previous-user-updates-table",
                propName: "UserRequest.Id",
                hasFilters: true,
                tableFilters: [
                    new FilterTab("previous-user-updates-general", "General", "previous-updates-general",
                        [
                            new Filter("previous-user-updates-status", "Request Status", "multi-select-pl-single", "UserRequest.StatusId", "pl-status-type"),
                            new Filter("previous-user-updates-type", "Request Type", "multi-select-pl-single", "UserRequest.TypeId", "pl-request-type"),
                            new Filter("previous-user-updates-center", "Associated Center", "multi-select-pl-multi", "UserRequest.RequestCenterIds", "pl-center")
                        ]
                    )
                ],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.previousUserUpdateTable.getDisplayStatus(data) } },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.previousUserUpdateTable.getPickListContent(data, "pl-request-type") } },
                    { data: "UserRequest.RequestCenterIds", title: "Center", className: "text-left font-size12", render: (data) => { return this.previousUserUpdateTable.getMultiSelectString(data, "pl-center") } },
                    { 
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.LastUpdated;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.LastUpdated);
                            }
                        },
                        title: "Last Updated", className: "text-left font-size12 nowrap"
                    }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {                  
                    this.viewRequestController.openModal(requestId);
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests",
                tableVariableName: "previousUserUpdateTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId >= 3) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [6, 'desc']
            }

            // PM Review Requests
            this.pmReviewUpdateTableInfo = {
                tableId: "pm-user-review-table",
                propName: "UserRequest.Id",
                hasFilters: false,
                tableFilters: [],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.pmReviewUpdateTable.getDisplayStatus(data) } },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.RequestCenterIds", title: "Center", className: "text-left font-size12", render: (data) => { return this.pmReviewUpdateTable.getMultiSelectString(data, "pl-center") } },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.pmReviewUpdateTable.getPickListContent(data, "pl-request-type") } },
                    {
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.CreateDate;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.CreateDate);
                            }
                        },
                        title: "Request Date", className: "text-left font-size12 nowrap"
                    }
                    //{ data: "UserRequest.CreateDate", title: "Request Date", className: "text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data) } }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {
                    this.viewRequestController.openModal(requestId);
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests",
                tableVariableName: "pmReviewUpdateTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId == 1) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [6, 'asc']
            }
        });
    }

    async selectList(e: Event, strIndex: string) {
        if (this.currentListIndex == strIndex) return;
        this.currentListIndex = strIndex;

        let currentTarget = $(e.currentTarget);
        $(".list-item-selector-container").find(".list-item-selector").removeClass("active");
        currentTarget.addClass("active");

        await this.initializeSection(strIndex);
    }

    async initializeSection(strIndex: string) {
        // Users
        if (strIndex == "1") {
            this.showSection(strIndex);
            this.userListController = new ListController(this.userListInfo);
            this.currentListController = this.userListController;
            await this.setRequestsFoundCount();
        }
        // User Requests
        else if (strIndex == "2") {
            this.showLoading(true);
            this.showSection(strIndex);

            this.generateSectionContent("request-content-container", this.userRequestTableInfo);
            this.userRequestTable = new PmUserTable(this.userRequestTableInfo);
            await this.userRequestTable.initialize();
            this.generateSectionContent("previous-user-updates-content", this.previousUserUpdateTableInfo);
            this.previousUserUpdateTable = new PmUserTable(this.previousUserUpdateTableInfo);
            await this.previousUserUpdateTable.initialize();

            let userRequestObj = await this.getUserRequestList();
            let userRequests = userRequestObj['items'];
            let pickLists = userRequestObj['pickLists'];
            this.reviewRequestController.updateStoredLists(userRequests, pickLists);
            this.newAddRequestController.updateStoredLists(userRequests, pickLists);
            this.viewRequestController = new ViewUserRequestController("view-request-modal", userRequests, pickLists);

            this.currentRequests = userRequests;
            await this.setRequestsFoundCount();

            this.showLoading(false);
            this.resizeTable(this.userRequestTable);
            this.resizeTable(this.previousUserUpdateTable);

            $(".collapse-table-container").on('shown.bs.collapse', () => {
                this.resizeTable(this.previousUserUpdateTable);
            })
        }
        // Users in PM Review
        else if (strIndex == "3") {
            this.showLoading(true);
            this.showSection(strIndex);

            this.generateSectionContent("pm-request-content-container", this.pmReviewUpdateTableInfo);
            this.pmReviewUpdateTable = new PmUserTable(this.pmReviewUpdateTableInfo);
            await this.pmReviewUpdateTable.initialize();

            let userRequestObj = await this.getUserRequestList();
            let userRequests = userRequestObj['items'];
            let pickLists = userRequestObj['pickLists'];
            this.viewRequestController = new ViewUserRequestController("view-request-modal", userRequests, pickLists);

            this.currentRequests = userRequests;
            await this.setRequestsFoundCount();

            this.showLoading(false);
            this.resizeTable(this.pmReviewUpdateTable);
        }

        // Pick Lists
        else if (strIndex == "99") {
            this.pickListController = new PickListController("pick-list-content", "UserPickLists", "SavePickListOption");
            await this.setRequestsFoundCount();
            this.showSection(strIndex);
        }
    }

    showSection(sectionId: string) {
        if (sectionId == "1") {
            $("#list-management-content").removeClass("d-none");
            $("#pick-list-content").addClass("d-none");
            $("#request-content").addClass("d-none");
            $("#pm-request-content").addClass("d-none");
        }
        else if (sectionId == "2") {
            $("#list-management-content").addClass("d-none");
            $("#pick-list-content").addClass("d-none");
            $("#request-content").removeClass("d-none");
            $("#pm-request-content").addClass("d-none");
        }
        else if (sectionId == "3") {
            $("#list-management-content").addClass("d-none");
            $("#pick-list-content").addClass("d-none");
            $("#request-content").addClass("d-none");
            $("#pm-request-content").removeClass("d-none");
        }
        else if (sectionId == "99") {
            $("#list-management-content").addClass("d-none");
            $("#pick-list-content").removeClass("d-none");
            $("#request-content").addClass("d-none");
            $("#pm-request-content").addClass("d-none");
        }
    }

    async setRequestsFoundCount(): Promise<any> {
        let target = $("#user-request-count");
        if (this.currentRequests == undefined) {
            let userRequestObj = await this.getUserRequestList();
            let userRequests: UserRequestExtended[] = userRequestObj['items'];
            this.currentRequests = userRequests;
            let foundUserRequests = this.currentRequests.filter(request => request.UserRequest.StatusId == 2);
            target.text(foundUserRequests.length.toString());
        }
        else {
            let foundUserRequests = this.currentRequests.filter(request => request.UserRequest.StatusId == 2);
            target.text(foundUserRequests.length.toString());
        }
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }

    generateSectionContent(sectionId: string, tableInfo: PmUserTableInfo) {
        let targetSectionContainer = $(`#${sectionId}`);

        let filterHtml = "";
        if (tableInfo.hasFilters) {
            filterHtml = this.generateFilterTabContent(tableInfo);
        }

        let detailMenuClass = "";
        if (tableInfo.hasDetailMenu) {
            detailMenuClass = "detail-menu-table"
        }

        let tableHtml = `
            <div class="list-table-container mt-4">
                <div class="revampp-datatable">
                    <table id="${tableInfo.tableId}" class="table table-striped selectable-rows w-100 ${detailMenuClass}" style="width:100%"></table>
                </div>
            </div>
        `;

        if (tableInfo.hasDetailMenu) {
            tableHtml += `
            <div id="detail-menu-container-${tableInfo.tableId}">

            </div>
            `;
        }

        let html = `
            ${filterHtml}
            ${tableHtml}
        `;

        targetSectionContainer.empty().html(html);
    }

    generateFilterTabContent(tableInfo: PmUserTableInfo): string {
        let html = "";

        if (tableInfo.tableFilters.length == 1) {
            html = `
                <div class="col-12 px-0 text-right mb-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary font-size11" onclick="page.${tableInfo.tableVariableName}.resetFilters()">Reset Filters</button>
                </div>
                <div id="list-filter-tab-container">
                    <ul class="nav nav-tabs justify-content-start border-bottom-0" id="pm-table-filter-tabs-${tableInfo.tableId}" role="tablist">
                
                    </ul>
                </div>

                <div class="tab-content pm-filters-block" id="pm-table-filter-container-${tableInfo.tableId}">
            
                </div>
            `
        }
        else {
            html = `
                <div class="col-12 px-0 text-right">
                    <button type="button" class="btn btn-sm btn-outline-secondary font-size11" onclick="page.${tableInfo.tableVariableName}.resetFilters()">Reset Filters</button>
                </div>
                <div id="list-filter-tab-container">
                    <ul class="nav nav-tabs justify-content-start border-bottom-0" id="pm-table-filter-tabs-${tableInfo.tableId}" role="tablist">
                
                    </ul>
                </div>

                <div class="tab-content pm-filters-block" id="pm-table-filter-container-${tableInfo.tableId}">
            
                </div>
            `
        } 

        return html;
    }

    resizeTable(table: PmUserTable) {
        table.resizeTable();
    }

    showLoading(isLoading: boolean): void {
        if (isLoading) {
            this.loadingContent.removeClass("d-none");
            this.loadedContent.addClass("d-none");
        }
        else {
            this.loadingContent.addClass("d-none");
            this.loadedContent.removeClass("d-none");
        }
    }

    validateWelcomeEmail(): boolean {
        let updatedUser: AppUserExtended = this.newAddRequestController.getUpdatedUser();
        if (updatedUser.AppUser.IsActive) {
            this.showErrorMessage(false);
            return true;
        }
        else {
            this.showErrorMessage(true, "This user is currently inactive. Please update their portal access before sending a welcome email.")
            return false;
        }
    }

    showErrorMessage(shouldShow: boolean, errorMessage: string = ""): void {
        let errorBlock = $(`#${this.newAddRequestController.id}-submit-error`);
        if (shouldShow) {
            errorBlock.text(errorMessage);
            errorBlock.removeClass("d-none");
        }
        else {
            errorBlock.text("");
            errorBlock.addClass("d-none");
        }
    }

    async getUserRequestList(): Promise<any> {
        let route = "/secure/user-management/user-management?handler=UserRequests";

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: route,
                method: "GET",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async saveApprovedRequest(): Promise<any> {
        // Show Modal Loading
        this.reviewRequestController.showLoading(true);

        // Get Current Request
        let currentRequest: UserRequestExtended = _.cloneDeep(this.reviewRequestController.currentRequest);
        if (currentRequest != null) {
            // Get Current App User Object (after updates)
            let updatedUserArr: AppUserExtended[] = this.reviewRequestController.editController.updatedItems;
            if (updatedUserArr.length == 1) {
                let updatedUser: AppUserExtended = updatedUserArr[0];
                currentRequest.AppUserExtended = updatedUser;

                // Send Request
                await this.sendApprovedRequest(currentRequest);
            }
        }

        this.reviewRequestController.showSaved(true);

        // Refresh Table
        await this.initializeSection("2");

        setTimeout(() => {
            $(`#${this.reviewRequestController.modalIdTarget}`).modal('hide');
            setTimeout(() => {
                this.reviewRequestController.showLoading(false);
                this.reviewRequestController.showSaved(false);
            }, 1000);
        }, 1000);
    }

    async saveDenyRequest(): Promise<any> {
        // Show Modal Loading
        this.reviewRequestController.showLoading(true);

        // Get Current Request
        let currentRequest: UserRequestExtended = _.cloneDeep(this.reviewRequestController.currentRequest);
        if (currentRequest != null) {
            // Get Current App User Object (after updates)
            let updatedUserArr: AppUserExtended[] = this.reviewRequestController.editController.updatedItems;
            if (updatedUserArr.length == 1) {
                let updatedUser: AppUserExtended = updatedUserArr[0];
                currentRequest.AppUserExtended = updatedUser;

                // Send Request
                await this.sendDenyRequest(currentRequest);
            }
        }

        this.reviewRequestController.showSaved(true);

        // Refresh Table
        await this.initializeSection("2");

        setTimeout(() => {
            $(`#${this.reviewRequestController.modalIdTarget}`).modal('hide');
            setTimeout(() => {
                this.reviewRequestController.showLoading(false);
                this.reviewRequestController.showSaved(false);
            }, 1000);
        }, 1000);
    }

    async completeNewUserRequest(sendWelcomeEmail: boolean = true): Promise<any> {
        let isValid = this.newAddRequestController.validate();
        let isWelcomeEmailValid = true;
        if (sendWelcomeEmail) {
            isWelcomeEmailValid = this.validateWelcomeEmail();
        }
        else {
            this.showErrorMessage(false);
        }

        if (!isValid || !isWelcomeEmailValid) {
            return;
        }

        // Show Modal Loading
        this.newAddRequestController.showLoading(true);

        // Get AppUser & Request
        let updatedUser: AppUserExtended = this.newAddRequestController.getUpdatedUser();
        let request: UserRequestExtended = this.newAddRequestController.currentRequest;

        if (updatedUser != null && request != null) {
            await this.sendApprovedNewUserRequest(updatedUser, request.UserRequest.Id, sendWelcomeEmail);
        }

        this.newAddRequestController.showSaved(true);

        // Refresh Table
        await this.initializeSection("2");

        setTimeout(() => {
            $(`#${this.newAddRequestController.modalIdTarget}`).modal('hide');
            setTimeout(() => {
                this.newAddRequestController.showLoading(false);
                this.newAddRequestController.showSaved(false);
            }, 1000);
        }, 1000);
    }

    async denyNewUserRequest(): Promise<any> {
        // Show Modal Loading
        this.newAddRequestController.showLoading(true);

        // Get AppUser & Request
        let updatedUser: AppUserExtended = this.newAddRequestController.getUpdatedUser();
        let request: UserRequestExtended = this.newAddRequestController.currentRequest;

        if (updatedUser != null && request != null) {
            await this.sendDenyNewUserRequest(updatedUser, request.UserRequest.Id);
        }

        this.newAddRequestController.showSaved(true);

        // Refresh Table
        await this.initializeSection("2");

        setTimeout(() => {
            $(`#${this.newAddRequestController.modalIdTarget}`).modal('hide');
            setTimeout(() => {
                this.newAddRequestController.showLoading(false);
                this.newAddRequestController.showSaved(false);
            }, 1000);
        }, 1000);
    }

    async sendApprovedRequest(request: UserRequestExtended): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/user-management/user-management?handler=ApproveRequest`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(request)}
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async sendDenyRequest(request: UserRequestExtended): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/user-management/user-management?handler=DenyRequest`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(request) }
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async sendApprovedNewUserRequest(newUser: AppUserExtended, requestId: number, sendWelcomeEmail: boolean = true): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/user-management/user-management?handler=ApproveNewUser`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(newUser), requestId:  requestId, sendWelcomeEmail: sendWelcomeEmail }
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async sendDenyNewUserRequest(newUser: AppUserExtended, requestId: number): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/user-management/user-management?handler=DenyNewUser`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(newUser), requestId: requestId }
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    openTeamsModal() {
        let currentUsers = this.currentListController.listItems;
        this.teamsAccessModal.openModal(currentUsers);
    }

}